const DepositCustomer = () =>
  import('@/views/main/consumer/depositCustomer/DepositCustomer.vue')

export default {
  path: '/main/consumer/depositCustomer',
  name: 'DepositCustomer',
  component: DepositCustomer,
  children: []
}
